<main>
  <div class="main-page-wrapper overflow-hidden">
    <app-header></app-header>
    <app-hero-area></app-hero-area>
  </div>
</main>
